<template>
    <div
        class="fullwidth-wrapper__content"
        @mousedown="handleMouseDown"
        @mouseup="handleMouseUp"
        @mousemove="handleMouseMove"
        @mouseleave="handleMouseLeave">
        <table class="match-table match-table--rank">
            <thead>
                <tr>
                    <th></th>
                    <th
                        class="match-table__header-cell"
                        v-for="(trait, index) in sortedTraits"
                        :key="`person-id-${index}`">
                        <router-link
                            class="match-table__header-cell-button button--transparent"
                            :to="{
                                name: 'profiling',
                                params: {
                                    partnerId: trait.same_id_person
                                }
                            }">
                            <div class="person-circle person-circle--large match-table__person-circle">
                                {{ trait.match.substring(0, 2) }}
                            </div>
                            <span class="match-table__person-name">{{ trait.match.toLowerCase() }}</span>
                        </router-link>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr class="match-table__score">
                    <td class="match-table__body-cell">{{ $t("ranking") }}</td>
                    <td
                        class="match-table__body-cell"
                        v-for="(trait, index) in sortedTraits"
                        :key="`person-score-${index}`">
                        {{ index + 1 }}
                    </td>
                </tr>
                <tr class="match-table__row">
                    <td class="match-table__body-cell"></td>
                    <td
                        v-for="(trait, indextraits) in sortedTraits"
                        :key="`trait-${indextraits}`"
                        class="match-table__body-cell">
                        <div
                            class="match-table__rank-bar"
                            :style="`height: ${trait.ratio * baseBarHeightPercent}px;`"><span class="sr-only">{{ trait.ratio }}</span></div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
// @ is an alias to /src

import { capitalize } from "@/utils/helpers/string.js";

export default {
    name: "MatchRankingTable",
    components: {
    },
    props: {
        groupTraits: {
            type: Array,
            required: true
        },
        currentType: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            baseBarHeightPercent: 4,
            x: 0,
            y: 0,
            top: 0,
            left: 0,
            isMouseDown: false,
            isDragEnable: false
        };
    },
    computed: {
        compareType() {
            switch (this.currentType) {
            case "adaptation":
                return "samesame";
            case "popularity":
                return "attractedTo";
            case "opponent":
                return "loveAttractedTo";
            }
        },
        titles() {
            switch (this.currentType) {
            case "adaptation":
                return [
                    this.$t("adaptation-most-adaptative", {x: capitalize(this.sortedTraits[0].match)}),
                    this.$t("adaptation-falls-apart", {x: capitalize(this.sortedTraits[this.sortedTraits.length - 1].match)})
                ];
            case "popularity":
                return [
                    this.$t("popularity-is-the-most-popular", {x: capitalize(this.sortedTraits[0].match)}),
                ];
            case "opponent":
                return [
                    this.$t("rival-most-attracted-by-circle-love", {x: capitalize(this.sortedTraits[0].match)}),
                ];
            default:
                return false;
            }
        },
        // currentTraits
        // Filtered list of traits based on report_name === "ap" && compareType
        currentTraits() {
            if (this.groupTraits) {

                const traits = this.groupTraits.filter((trait) => {
                    if (trait.report_name !== "ap") {
                        return false;
                    }

                    if (trait.compare !== this.compareType) {
                        return false;
                    }

                    return true;
                });

                return traits;
            }

            return;
        },
        sortedTraits() {

            const traits = this.currentTraits;

            const rankedTraits = traits.sort((a, b) => {
                return parseFloat(b.ranking) - parseFloat(a.ranking);
            });

            return rankedTraits;
        }
    },
    watch: {
        titles (value) {
            this.updateSubtitle(value);
        }
    },
    mounted() {
        this.updateSubtitle(this.titles);
    },
    methods: {
        handleMouseUp() {
            this.isMouseDown = false;
        },
        handleMouseDown() {
            this.isMouseDown = true;
            this.y = event.pageY;
            this.x = event.pageX;
            this.top = this.$el.parentNode.scrollTop;
            this.left = this.$el.parentNode.scrollLeft;
        },
        handleMouseMove(event) {
            this.isDragEnable = true;
            if (this.isDragEnable && this.isMouseDown) {
                this.$el.parentNode.scrollLeft = this.left - event.pageX + this.x;
                this.$el.parentNode.scrollTop = this.top - event.pageY + this.y;
            }
        },
        handleMouseLeave() {
            this.isDragEnable = false;
        },
        updateSubtitle(value) {
            this.$emit("update-subtitle", value);
        }
    }
};
</script>

